import { Box } from '@mui/material';
import React, { useState } from 'react';
import MiniDrawer from '../sidebar/sidebar';
import { useUserStore } from '../../stores/user-store';
import { useNavigate } from 'react-router-dom';
import Login from '../../components/Login';
import { Dashboard } from '../../components/Dashboard';
import GPTScreen from '../../components/GPT/ChatCtrl';
//import Password from '../../components/Password';


export const SinglePageLayout = (props) => {

   // alert( props.component.name);

    const userData = useUserStore;
    const navigate = useNavigate();

    if (userData.getState().isLogin != true) {
            return (<Box>
                <Login />
            </Box>);
    }

    const navigateTo = (elem) => {
        navigate('/' + elem, { replace: true });
    }
    // console.log(userData.getState().isLogin);
    // console.log(props.component.name);
    return (
        <Box>
            {
                userData.getState().isLogin == true ?
                        <Box>
                              <GPTScreen></GPTScreen>
                        </Box>
                    :
                    navigate('/login', { replace: true })
            }

        </Box>
    )

}